import { useState } from "react";
import { num } from "@/lib/format";
import { Progress } from "@/components/ui/progress";
import { ChevronDown, ChevronRight } from "lucide-react";

export const SizeYieldTable = ({ rows, testid }) => (
  <div className="grid grid-cols-[3rem_1fr_auto] items-center gap-x-3 gap-y-1.5 text-xs" data-testid={testid}>
    {rows.map((r) => (
      <div key={r.size} className="contents">
        <span className="font-mono-erp font-semibold">{r.size}</span>
        <Progress value={Math.min(100, r.ratio || 0)} className="h-1.5" />
        <span className="text-right text-muted-foreground">{num(r.sold)}/{num(r.produced)}{r.ratio != null ? ` · ${r.ratio}%` : " · non prodotta"}</span>
      </div>
    ))}
  </div>
);

export const SellThroughRow = ({ s }) => {
  const [open, setOpen] = useState(false);
  const canOpen = s.sizes?.length > 0;
  return (
    <div data-testid={`sellthrough-${s.sku}`}>
      <button onClick={() => canOpen && setOpen(!open)} className={`w-full text-left ${canOpen ? "" : "cursor-default"}`} data-testid={`sellthrough-toggle-${s.sku}`}>
        <div className="mb-1.5 flex items-center justify-between gap-2 text-sm">
          <span className="flex min-w-0 items-center gap-1 font-medium">
            {canOpen && (open ? <ChevronDown className="h-4 w-4 shrink-0 text-muted-foreground" /> : <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />)}
            <span className="truncate">{s.name}</span>
            {s.color && s.color !== "N/D" && <span className="ml-1 shrink-0 text-xs font-normal text-muted-foreground" data-testid={`sellthrough-color-${s.sku}`}>· {s.color}</span>}
          </span>
          <span className="shrink-0 font-mono-erp text-xs text-muted-foreground">{s.produced ? `${num(s.sold)}/${num(s.produced)} · ${s.ratio}%` : `${num(s.sold)} venduti · prodotto da inserire`}</span>
        </div>
        <Progress value={Math.min(100, s.ratio)} className="h-2" />
      </button>
      {open && <div className="ml-5 mt-3 border-l border-border/60 pl-3"><SizeYieldTable rows={s.sizes} testid={`sellthrough-sizes-${s.sku}`} /></div>}
    </div>
  );
};
